export const enum SSO_PROVIDERS {
  ENTRAID = 'entraid',
  KEYENCE = 'keyence',
}

export const SSO_PROVIDERS_LIST: readonly string[] = [SSO_PROVIDERS.ENTRAID, SSO_PROVIDERS.KEYENCE];

export const SSO_DOMAIN_PROVIDER_MAP: Record<string, SSO_PROVIDERS> = {
  'ceva.com': SSO_PROVIDERS.ENTRAID,
  'filavie.com': SSO_PROVIDERS.ENTRAID,
  'keyence.co.jp': SSO_PROVIDERS.KEYENCE,
  'laprovet.com': SSO_PROVIDERS.ENTRAID,
};
